import { atom } from 'jotai';
import { ColourSchemeGenerator, ItemsColourScheme } from '../../util/ColourSchemeGenerator';
import { sectorsAtom } from './AppConfigStateJ';

export const sectorsColourState = atom<ItemsColourScheme<string>>((get) => {
  const sectors = get(sectorsAtom);
  const sectorNames = sectors.map((sector) => sector.displayName);

  return ColourSchemeGenerator.getInstance().generateScheme<string>('sectorColours', sectorNames);
});
